import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { LocationStatusReportCSV, MovementsReportCSV } from "Services/warehouse.report.service";

const replacer = (key: string, value: string) => value ?? "";

export const jsonToCsv = (items: any[]) => {
  const header = Object.keys(items[0]);
  const headerString = header.join(",");

  const rowItems = items.map((row) =>
    header.map((fieldName) => JSON.stringify(row[fieldName as any], replacer)).join(",")
  );

  return [headerString, ...rowItems].join("\r\n");
};

export const handleGenerateMovementsAndLocationStatusCSV = ({
  data,
  reportName,
  companyName
}: {
  data: LocationStatusReportCSV[] | MovementsReportCSV[];
  reportName: string;
  companyName?: string;
}) => {
  const formatedDate = format(
    utcToZonedTime(new Date(), Intl.DateTimeFormat().resolvedOptions().timeZone),
    "dd_MM_yyyy"
  );

  const filename = `${formatedDate}_${reportName}_${companyName
    ?.split(" ")
    .join("_")}`;
  const extension = "csv";
  const fileNameWithExtension = `${filename}.${extension}`;
  const jsonString = `data:text/csv;chatset=utf-8,${encodeURIComponent(jsonToCsv(data))}`;
  const link = document.createElement("a");

  link.href = jsonString;
  link.download = fileNameWithExtension;
  document.body.appendChild(link);

  link.click();
  link.remove();
};
